/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { IncomingContent } from '@/data/types/IncomingContent';
import { Layout } from '@/data/types/Layout';

export const getSharedWishListView = (props: IncomingContent): Layout => ({
	name: 'DoubleStack',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		first: [{ name: 'BreadcrumbTrail', id: 'breadcrumb-trail-widget' }, { name: 'SharedWishListView', id: 'SharedWishListView' }],
		third: [{ name: 'MyAccountFooter', id: 'my_account_footer' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	}
});
